// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"976":"f6efd62f","5225":"c96ff289"}[chunkId] + ".chunk.css";
};